
import React, { useEffect, useState, lazy, Suspense } from "react";
// import { HelmetProvider } from "react-helmet-async";
// import { Helmet, HelmetProvider } from "react-helmet-async";
import MainCard from "../../components/cards/MainCard";
import SubCard from "../../components/cards/SubCard";
import CategoryGrid from "../../components/cards/CategoryGrid";
import Article from "../../components/cards/Article";
import Ads from "../../components/cards/Ads";

// Lazy-loaded sections
const EconomyNews = lazy(() => import("../../components/cards/EconomyNews"));
const MediaNews = lazy(() => import("../../components/cards/MediaNews"));
const ReportNews = lazy(() => import("../../components/cards/ReportNews"));
const TodayNew = lazy(() => import("../../components/cards/TodyNew"));

export default function Home() {
  const [mainData, setMainData] = useState([]);
 
  useEffect(() => {
    const fetchMain = async () => {
      try {
        const res = await fetch("https://ppmn.net/dash/api/main/Section");
        const data = await res.json();
        setMainData(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Main news fetch failed:", err);
      }
    };
    fetchMain();
  }, []);

  const mainArticle = mainData[0];
  const subArticles = mainData.slice(1, 5);

  return (
    // <HelmetProvider>
      <div className="container">
            <Ads />

        {/* <Helmet> */}
          <title>شبكة الصحافة والإعلام الفلسطينية</title>
          <meta name="description" content="تابع أحدث الأخبار العاجلة من فلسطين والعالم مع تغطية يومية وتحليلات شاملة لجميع الأحداث." />
          <meta name="keywords" content="أخبار فلسطين, عاجل, سياسة, اقتصاد, رياضة, أخبار اليوم, شبكة الأخبار الفلسطينية" />
          <meta name="author" content="Palestinian Press and Media Network" />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href="https://your-domain.com/" />
          <meta property="og:title" content="شبكة الأخبار الفلسطينية | الصفحة الرئيسية" />
          <meta property="og:description" content="تابع أحدث الأخبار العاجلة من فلسطين والعالم." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://your-domain.com/" />
          <meta property="og:image" content="https://your-domain.com/logo.png" />
          <meta name="twitter:card" content="summary_large_image" />
        {/* </Helmet> */}
                  {/* name={item.article_category_name} */}

        {/* Main Hero News */}
        <div className="row pt-3">
          {mainArticle && (
            <MainCard
            id={mainArticle.article_id}
              img={mainArticle.article_title_image}
              title={mainArticle.article_title}
              content={mainArticle.article_content}
              slug={mainArticle.article_slug}
              // name={mainArticle.article_category_name}
              name={mainArticle.article_category_name}
              
            />
          )}

          {/* Sub Articles */}
          <div className="col-lg-6 pt-3">
            <div className="row">
              {subArticles.map((item) => (
                <SubCard
                  id={item.article_id}
                  img={item.article_title_image}
                  title={item.article_title}
                  content={item.article_content}
                  slug={item.article_slug}
                  // name={item.articl_articl.name}
                  name={item.article_category_name}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Progressive Sections */}
        <Suspense fallback={<div className="text-center my-5">جاري تحميل أخبار اليوم…</div>}>
          <TodayNew />
        </Suspense>



        <Suspense fallback={<div className="text-center my-5">جاري تحميل التقارير الخاصة…</div>}>
          <Article />
        </Suspense>


        <Suspense fallback={<div className="text-center my-5">جاري تحميل التقارير الخاصة…</div>}>
          <ReportNews />
        </Suspense>
<Ads/>
         <Suspense fallback={<div className="text-center my-5">جاري تحميل الأخبار الاقتصادية…</div>}>
          <EconomyNews />
        </Suspense>

      

        <CategoryGrid />

          <Suspense fallback={<div className="text-center my-5">جاري تحميل الأخبار الإعلامية…</div>}>
          <Ads />
          <MediaNews />
        </Suspense>
      </div>
    // </HelmetProvider>
  );
}
